import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchLogEntries } from '../services/api'; // Use your API file

export const getLogEntries = createAsyncThunk('logEntries/getLogEntries', async () => {
    const response = await fetchLogEntries(); // Pass reviewId if available
    return response.data;
});

const LogEntrySlice = createSlice({
    name: 'logEntries',
    initialState: {
        logEntries: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getLogEntries.pending]: (state) => {
            state.status = 'loading';
        },
        [getLogEntries.fulfilled]: (state, action) => {
            state.logEntries = action.payload.data;
            state.status = 'succeeded';
        },
        [getLogEntries.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default LogEntrySlice.reducer;